import * as React from "react";
import { SectionCollapsibleArrow } from "../SectionCollapsibleArrow";
export const Section = React.memo(function Section({ isExpanded, title, children, onClick, animationConfig, sectionRef, }) {
    // eslint-disable-next-line no-null/no-null
    const contentRef = React.useRef(null);
    const contentStyle = React.useMemo(() => ({
        gridTemplateRows: `${+isExpanded}fr`,
        transition: `all ${animationConfig.duration}ms ${animationConfig.ease}`,
    }), [isExpanded, animationConfig]);
    return (React.createElement("div", { className: "section", ref: sectionRef },
        React.createElement("button", { type: "button", className: "section-button", onClick: onClick, "data-testid": "collapsible-section", "aria-expanded": isExpanded },
            React.createElement("div", { className: "section-button__title" }, title),
            React.createElement(SectionCollapsibleArrow, { isExpanded: isExpanded })),
        React.createElement("div", { className: 'section-collapsible__content', ref: contentRef, 
            // TODO: Add cleaner solution here with pure CSS once `calc-size()` is widely supported by browsers.
            style: contentStyle },
            React.createElement("div", { className: 'section-collapsible__content-inner', style: { overflow: "hidden" } }, isExpanded && children))));
});
//# sourceMappingURL=Section.js.map